__turbopack_context__.v({
  "radiobutton": "zj1LvW_radiobutton",
  "radiobuttongroup": "zj1LvW_radiobuttongroup",
  "radiobuttongroup__content": "zj1LvW_radiobuttongroup__content",
  "radiobuttongroup__withcontent": "zj1LvW_radiobuttongroup__withcontent",
  "radiobuttonlabel": "zj1LvW_radiobuttonlabel",
  "radiobuttonwrapper": "zj1LvW_radiobuttonwrapper",
});
